export default "__VITE_ASSET__DNidXj2z__"